import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../category/category.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

const addCategoryEndPoints = ApiEndpoints.category.categoryCreate;
export default function EditEmails() {
  const [formData, setFormData] = useState({
    to: "",
    cc: "",
    bcc: "",
    formType: "",
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      // const payload = { name, };
      // try {
      //   await ApiRequest("POST", addCategoryEndPoints, payload);
      //   navigate("/admin/category");
      // } catch (error) {
      //   console.error("There was an error creating the author!", error);
      //   alert("There was an error creating the author!");
      // }
      console.log(formData)
    }, [navigate,formData]);

  return (
    <>
      <div className="header-add-category">
        <h5>Add Emails</h5>
      </div>
      <div className="add-category-content">
        <form onSubmit={handleSubmit}>
          
          <label>To*:</label>
          <input value={formData.to} name="to" placeholder="Ex. example1@gmail.com,example2@gmail.com,..." type="text" required className="form-control" onChange={handleChange}/>

          <label>Cc:</label>
          <input value={formData.cc} name="cc" placeholder="Ex. example1@gmail.com,example2@gmail.com,..." type="text" className="form-control" onChange={handleChange}/>

          <label>Bcc:</label>
          <input value={formData.bcc} name="bcc" placeholder="Ex. example1@gmail.com,example2@gmail.com,..." type="text" className="form-control" onChange={handleChange}/>

          <label>Form Type*:</label>
          <select className="form-control" name="formType" value={formData.formType} onChange={handleChange}>
            <option value="">Select Form Type</option>
            <option value="popup_form">Popup Form</option>
            <option value="contact_form">Contact Form</option>
            <option value="landing_form">Landing Form</option>
            <option value="itneed_form">IT Needs Form</option>
          </select>

          <div className="submit-formbtn">
            <button type="submit" className="default-btn">
              submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
